"use client";

import { useState } from "react";

interface AddAccountFormProps {
  onAdded: () => void;
  disabled?: boolean;
}

export default function AddAccountForm({ onAdded, disabled }: AddAccountFormProps) {
  const [username, setUsername] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!username.trim()) return;

    setLoading(true);
    setError(null);

    try {
      const res = await fetch("/api/tracking/accounts", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ instagramUsername: username.trim() }),
      });
      const body = await res.json();
      if (!res.ok) throw new Error(body.error ?? "Failed to add account");

      setUsername("");
      onAdded();
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to add account");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className="rounded-2xl border border-line bg-surface p-4 shadow-soft">
      <label className="block text-sm font-semibold text-ink">Track a public account</label>
      <p className="mt-1 text-xs text-muted">Mock scrape - worker must be running locally or on Coolify.</p>
      <div className="mt-3 flex gap-2">
        <div className="relative flex-1">
          <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-muted">@</span>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="username"
            disabled={disabled || loading}
            className="w-full rounded-xl border border-line bg-bg py-2.5 pl-8 pr-3 text-sm outline-none focus:border-rose/50"
          />
        </div>
        <button
          type="submit"
          disabled={disabled || loading || !username.trim()}
          className="shrink-0 rounded-xl grad-bg px-4 py-2.5 text-sm font-semibold text-white disabled:opacity-50"
        >
          {loading ? "Adding…" : "Track"}
        </button>
      </div>
      {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
    </form>
  );
}
